import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { DeviceEffects } from "./+state/effects";
import { DeviceFacade } from "./+state/facades";
import { DeviceService } from "./+state/services";

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([DeviceEffects])],
  providers: [DeviceFacade, DeviceService]
})
export class DeviceDataAccessModule {}
